import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type {
  CheckoutDeliveryStepData,
  CheckoutShippingStepData,
  StandardCheckoutForm,
} from "./standardCheckoutFormSlice.types";

export const initialCheckoutFormState: StandardCheckoutForm = {
  isReady: false,
  shippingStepData: null,
  deliveryStepData: null,
};

export const standardCheckoutFormSlice = createSlice({
  name: "standardCheckoutForm",
  initialState: initialCheckoutFormState,

  reducers: {
    setReady(state) {
      state.isReady = true;
    },
    setShippingStepData(state, action: PayloadAction<CheckoutShippingStepData>) {
      state.shippingStepData = action.payload;
    },
    setDeliveryStepData(state, action: PayloadAction<CheckoutDeliveryStepData>) {
      state.deliveryStepData = action.payload;
    },
  },
});

export const { setShippingStepData, setDeliveryStepData, setReady } = standardCheckoutFormSlice.actions;
